import { useState, useEffect } from "react";
import {
  BodyComponent,
  TableComponent,
  ActionComponent,
  CreateButton, RefreshButton,
  trans,
  HeaderComponent,
  PaginationComponent
} from "@comps/components";
import { makeRequest } from "@utils/helpers";
import { Commons, Const, colors } from "../constants";
import { Badge, message, Tooltip } from 'antd';
import { FilterComponent, FilterButton } from "@comps/components";
import { deleteDataReq, getAllDataReq, getFilterReq, updateDataReq } from "./requests";
import CreateDelegation from "./components/CreateDelegation";
import ViewDelegation from "./components/ViewDelegation";
import { CheckOutlined, StopOutlined } from "@mui/icons-material";
import { Button } from 'antd';

const langKey = Const["delegation"].lngKey;

const pageConfig = {
  headers: {
    title: trans(`${langKey}.moduleName`),
    breadcrumb: [
      {
        name: trans(`${langKey}.moduleName`),
        path: Const["delegation"].route
      }
    ]
  }
}
//========================================
const IndexDelegation = (props) => {
  const totalRecords = 0;
  const [allData, setAllData] = useState({});
  const [dataSource, setDataSource] = useState([]);
  const [loader, setLoader] = useState(false);
  const [childComponent, setChildComponent] = useState(null);

  const [filters, setFilters] = useState();
  //start pagination states
  const [currentPage, setCurrentPage] = useState(1)
  const [pagination, setPagination] = useState({
    "total": 0,
    "count": 0,
    "per_page": 0,
    "current_page": 0,
    "total_pages": 0,
    "links": {}
  });
  //end pagination states

  // ==================================
  //   Use States End
  // ==================================

  // ==================================
  //   Table Data End
  // ==================================

  const columns = [

    {
      key: 'delegator_name',
      title: trans(`${langKey}.delegator_name`),
      dataIndex: "delegator_name",
    },
    {
      key: 'delegatee_name',
      title: trans(`${langKey}.delegatee_name`),
      dataIndex: "delegatee_name",
    },
    {
      key: 'delegation_types',
      title: trans(`${langKey}.delegation_types`),
      render: (record) => (
        record.types
      )
    },
    {
      key: 'remarks',
      title: trans(`${langKey}.remarks`),
      dataIndex: "remarks",
    },

    {
      key: 'status',
      title: trans(`${langKey}.status`),
      render: (record) => {
        return <Badge
          count={ record.status ? record.status : 'none' }
          style={ { background: colors[record.status_class], color: colors[record.status_class + '-color'] } }
        />
      }
    },

    {
      key: trans(Commons.actions),
      title: trans(Commons.actions), fixed: 'right',

      render: (record) => (
        <ActionComponent
          each={ record } modkey={ props.modkey }
          onView={ onView }
        >

          <Tooltip title={ record.status === 'Active' ? 'Deactivate' : 'Activate' } color={ record.status === 'Active' ? 'red' : 'green' }>
            <Button type="link" size="middle" onClick={ () => onChangeStatus(record) }>
              { record.status === 'Active' ?
                <StopOutlined className="icon-style da-text-color-info-1" /> :
                <CheckOutlined className="icon-style da-text-color-info-1" />
              }
            </Button>

          </Tooltip>
        </ActionComponent>
      ),
    },
  ];

  // ==================================
  //   Table Data End
  // ==================================

  useEffect(() => {
    getAllData();
    // eslint-disable-next-line
  }, [filters, currentPage]);

  const getAllData = () => {
    const payload = {
      page: currentPage,
      filters: filters
    }
    makeRequest(setLoader, getAllDataReq, payload, onSuccess, null);
  };

  const onSuccess = (response) => {
    setAllData(response)
    setPagination(response.delegations);
    setDataSource(response.delegations.data);
  };

  const onView = (record) => {
    setChildComponent(
      <ViewDelegation onCompleted={ onCompleted } record={ record } allData={ allData } disabled={ true } />
    );
  };

  const onDelete = (record) => {
    makeRequest(setLoader, deleteDataReq, record.id, onDeleted, onError);
  };
  const onDeleted = (res) => {
    onSuccess(res)
    setDataSource(res.delegations.data);
    message.success("Record Deleted")
  };

  const onChangeStatus = (record) => {
    const payload = { delegation: { ...record, is_active: record.status === 'Inactive' ? true : false } };
    makeRequest(setLoader, updateDataReq, payload, onChanged, onError);
  };
  const onChanged = (res) => {
    onSuccess(res)
    setDataSource(res.delegations.data);
    message.success("Record Updated")
  };

  const onError = (err, res) => {
    message.error(res.response.data.message);
    //setErrors(errorList);
  }

  // Create component modal
  const onCreate = () => {
    setChildComponent(<CreateDelegation onCompleted={ onCompleted } allData={ allData } onSuccess={ onSuccess } />);
  };

  const onCompleted = (data) => {
    if (data.length) {
      setDataSource(data);
    }
    setChildComponent(null);
    getAllData()
  };

  const handleTableChange = (page, fil, sorter) => {
    let payload = {
      ...pagination,
      current: page.current,
      pageSize: page.pageSize,
      sortName: sorter.field || "id",
      sortType: sorter.order === "ascend" ? "asc" : "desc",
    };
    setPagination(payload);
  };

  //---------------filters-----------------------
  const onOpenFilter = () => {
    setChildComponent(<FilterComponent filters={ filterFields } modkey={ props.modkey } selected={ filters } api={ getFilterReq } setCurrentPage={ setCurrentPage } onFilter={ setFilters } onCloseFilter={ onCloseFilter }
    />
    )
  }

  const onCloseFilter = () => {
    setChildComponent(null);

  }

  //----end filter--------------------

  return (
    <>

      { childComponent }
      <BodyComponent>
        <HeaderComponent headers={ pageConfig.headers } modkey={ props.modkey }>
          <RefreshButton onClick={ getAllData } /> <CreateButton onClick={ onCreate } />
          <FilterButton onClick={ onOpenFilter } />
        </HeaderComponent>
        <TableComponent modkey={ props.modkey }
          loader={ loader }
          columns={ columns }
          dataSource={ dataSource }
          pagination={ { ...pagination, total: totalRecords } }
          onChange={ handleTableChange }
        />
      </BodyComponent>
      <PaginationComponent pagination={ pagination } modkey={ props.modkey } setCurrentPage={ setCurrentPage } currentPage={ currentPage } />
    </>
  );
};

export default IndexDelegation;
const filterFields = [
  {
    type: "text",
    placeholder: "Name",
    key: "name"
  },
]

